import { t } from 'i18next';

export function checkErrorTelemetryDriSplitaoInverterHitachi(payload) {
  const fieldsToCheck = [
    'Alarm', 'Compressor', 'Fan', 'Fanspeed', 'Heater', 'Init',
    'Mode', 'Pdes', 'Psuc', 'Setpoint', 'SuperHeat',
    'TempAmb', 'ThermOn', 'Tsuc',
  ];

  const allFieldsNull = fieldsToCheck.every((field) => payload[field] === null);

  return allFieldsNull ? t('houveErro') : '';
}
